import { isLineOfBusiness } from "src/util/customerConfig";
import { FORECAST, PLANNER } from "../../pageModes";

import {
  GROUPED_BY_DEMAND,
  GROUPED_BY_SUPPLY,
  GROUPED_BY_CONSTRAINTS,
  QUICK_ACTIVITY_VIEW,
  CURRENT_GROUP_ONLY_VIEW,
  POSITION_VIEW,
} from "../../viewModes";

import buildGroupedByDemand from "./buildGroupedByDemand";
import buildGroupedBySupply from "./buildGroupedBySupply";
import buildGroupedByConstraints from "./buildGroupedByConstraints";
import buildPlannerGroupedBySupply from "./buildPlannerGroupedBySupply";
import buildPlannerGroupedByDemand from "./buildPlannerGroupedByDemand";
import buildPlannerLineOfBusiness from "./buildPlannerLineOfBusiness";

// Position view rows come from getForecastPositionViewRows, not the
// supply/demand line-item model. Shared ForecastPage hooks still
// destructure lookups (e.g. lineItemLookup), so a stub is required.
export const EMPTY_POSITION_VIEW_MODEL = {
  isPendingSubmit: false,
  columns: [],
  groupings: [],
  lookups: {
    allocationProjectLookup: {},
    columnLookup: {},
    groupingLookup: {},
    lineItemLookup: {},
    cellLookup: {},
    constraintCellLookup: {},
  },
};

export default ({
  mainQueryData,
  viewMode,
  pageMode,
  rootGroup,
  groupTypes = {},
  approvalReasons = {},
  hideHiddenTeams = false,
  showObjectives = false,
  shouldHash = false,
  isBudgetEnabled,
  useDeltaForBudget,
  overBudgetLimit,
  underBudgetLimit,
  isRealtimeFteMode,
  useRealtimeChangeOnly,
  useRealtimeFteDelta,
  enableDemandRequest = false,
  enableDemandRollupPlanning = false,
  enableSupplyForecastTargets = false,
}) => {
  if (pageMode === FORECAST) {
    switch (viewMode) {
      case GROUPED_BY_DEMAND:
      case CURRENT_GROUP_ONLY_VIEW: {
        return buildGroupedByDemand({
          rootGroup,
          data: mainQueryData,
          hideHiddenTeams,
          showObjectives,
          groupTypes,
          shouldHash,
          isBudgetEnabled,
          overBudgetLimit,
          underBudgetLimit,
          enableDemandRequest,
          enableDemandRollupPlanning,
        });
      }
      case GROUPED_BY_SUPPLY: {
        return buildGroupedBySupply({
          rootGroup,
          data: mainQueryData,
          insertExtraDemandGroupings: rootGroup.isSource,
          hideHiddenTeams,
          showObjectives,
          groupTypes,
          shouldHash,
          isBudgetEnabled,
          overBudgetLimit,
          underBudgetLimit,
          enableDemandRequest,
          enableDemandRollupPlanning,
          enableSupplyForecastTargets,
        });
      }
      case GROUPED_BY_CONSTRAINTS: {
        return buildGroupedByConstraints({
          rootGroup,
          data: mainQueryData,
          hideHiddenTeams,
          groupTypes,
          shouldHash,
        });
      }
      case POSITION_VIEW: {
        return EMPTY_POSITION_VIEW_MODEL;
      }
      default: {
        return {};
      }
    }
  }

  if (pageMode === PLANNER) {
    if (isLineOfBusiness(groupTypes, rootGroup)) {
      return buildPlannerLineOfBusiness({
        rootGroup,
        data: mainQueryData,
        hideHiddenTeams,
        showObjectives,
        groupTypes,
        shouldHash,
      });
    }
    switch (viewMode) {
      case GROUPED_BY_DEMAND: {
        return buildPlannerGroupedByDemand({
          rootGroup,
          data: mainQueryData,
          hideHiddenTeams,
          showObjectives,
          groupTypes,
          shouldHash,
          isBudgetEnabled,
          useDeltaForBudget,
          overBudgetLimit,
          underBudgetLimit,
          isRealtimeFteMode,
          useRealtimeChangeOnly,
          useRealtimeFteDelta,
          enableDemandRequest,
          enableDemandRollupPlanning,
        });
      }
      case GROUPED_BY_SUPPLY: {
        return buildPlannerGroupedBySupply({
          rootGroup,
          data: mainQueryData,
          insertExtraDemandGroupings: rootGroup.isSource,
          hideHiddenTeams,
          showObjectives,
          groupTypes,
          approvalReasons,
          shouldHash,
          isBudgetEnabled,
          useDeltaForBudget,
          overBudgetLimit,
          underBudgetLimit,
          enableDemandRollupPlanning,
        });
      }
      case QUICK_ACTIVITY_VIEW: {
        return buildPlannerGroupedBySupply({
          rootGroup,
          data: mainQueryData,
          insertExtraDemandGroupings: false,
          hideHiddenTeams,
          showObjectives,
          groupTypes,
          approvalReasons,
          shouldHash,
        });
      }
      default: {
        return {};
      }
    }
  }

  return {};
};
